import { environments } from '@/const/environments';
import { createAxios } from './base.httpClient';

export const apiHttpClient = createAxios({
    baseURL: environments.API_BASE_URL,
    timeout: environments.API_TIMEOUT || 30_000,
});
